export default __webpack_public_path__ + "static/media/sport-blue.4cd53ac7.svg";